export const SHOW_DEVICELOCK_MODAL = 'SHOW_DEVICELOCK_MODAL';
export const HIDE_DEVICELOCK_MODAL = 'HIDE_DEVICELOCK_MODAL';
